// extracted by mini-css-extract-plugin
export default {"dot1":"loading_dot1__yd9RK","dot2":"loading_dot2__zSsF5","dot3":"loading_dot3__obyO-","dot4":"loading_dot4__lBWGb","dot5":"loading_dot5__MD0Df","scale":"loading_scale__EOMji"};